import { Injectable, NgZone } from '@angular/core';
import { MatSnackBar } from '@angular/material';
import { ToastMessageComponent } from 'src/app/toast-message/toast-message.component';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  error(arg0: string) {
    throw new Error('Method not implemented.');
  }

  constructor(private snackBar: MatSnackBar, private zone: NgZone) {
  }

  public showMessage(message: string, duration: number, icon?: string, description?: string) {
    this.zone.run(() => {
      this.snackBar.openFromComponent(ToastMessageComponent, {
        duration,
        verticalPosition: 'top',
        horizontalPosition: 'right',
        data: { message, icon, description },
        panelClass: 'custom-toast'
      });
    });
  }

  opnenComp(component: any) {
    this.snackBar.openFromComponent(component, {
      data: 'some data'
    });
  }
}
